/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-imports */

import * as React from 'react';
import { TextButton, IconButton } from '@oneaudi/unified-web-components';
import { UeContainer, UeElement, UeReference } from '@oneaudi/falcon-tools';
import type { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import Slider from 'react-slick';
import { useI18n } from '@oneaudi/i18n-context';
import { FeatureGalleryTextBlock } from '../feature-gallery-text-block/index';
import WLTPComponent from '../MediaDisclaimerAndWLTP';
import {
  CarouselContainer,
  ContentContainer,
  FlexContainer,
  SliderWrap,
  SlideText,
  SlickSlider,
  ImageContainer,
  TextBlockSlider,
  TextBlockContent,
} from './style';
import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { constants } from '../../../constants';
import { VideoPLayer } from '../feature-gallery-popeye-video';
import { useWindowSize } from '../../../helper/useWindowSize';
import { messages } from '../../../i18n/messages';
import ImageComponent from './Image';
import { trackClick } from '../../utilTrackingHelpers/click';
import { MaybeLink } from './MaybeLink';

interface FeatureGalleryProps {
  content?: any;
  localeService?: LocaleServiceV1;
  gallery?: any;
  theme?: string;
  autoplay?: boolean;
  autoplaySpeed?: number;
  mediaHeight?: string;
  trackingService: TrackingServiceV2;
}

const getRandomInt = () => {
  return Math.floor(Math.random() * 1000000);
};

const FeatureGallery: React.FC<FeatureGalleryProps> = (props) => {
  const [nav1, setNav1] = React.useState<Slider | null>(null);
  const [nav2, setNav2] = React.useState<Slider | null>(null);
  const startX = React.useRef<number | null>(null);
  const [lastInteraction, setLastInteraction] = React.useState<string>('click');

  const slider1 = React.useRef<Slider | null>(null);
  const slider2 = React.useRef<Slider | null>(null);
  const ref = React.useRef(null);
  const wltpRef = React.useRef(null);
  const [mediaSize, setMediaSize] = React.useState('Large');
  const size = useWindowSize();

  // eslint-disable-next-line
  const divRefSlide1 = React.useRef<HTMLDivElement | null>(null!);
  const divRefSlide2 = React.useRef<HTMLDivElement | null>(null);
  const fgData = props;

  const { gallery, autoplay, autoplaySpeed, mediaHeight = 'large', trackingService } = fgData;

  const slidesCount = gallery ? gallery.length - 1 : 0;
  const [isCurrent, setIsCurrent] = React.useState<number>(0);

  const ueElementImageProperty = `imageUrl${mediaSize}Viewport`;
  const ueElementVideoProperty = `videoUrl${mediaSize}Viewport`;
  const previousSlide = useI18n(messages.previousSlide);
  const nextSlide = useI18n(messages.nextSlide);
  const currentSlidAriaText = useI18n(messages.currentSlide);
  const jumpToAriaText = useI18n(messages.jumpTo);

  const isAlpha = !process.env.IS_LEGACY;

  React.useEffect(() => {
    const updateSize = () => {
      setMediaSize(window.innerWidth > 767 ? 'Large' : 'Small');
    };

    updateSize();

    window.addEventListener('resize', updateSize);
    return () => {
      window.removeEventListener('resize', updateSize);
    };
  }, []);

  React.useEffect(() => {
    // eslint-disable-next-line
    setNav1(slider1.current!);
    // eslint-disable-next-line
    setNav2(slider2.current!);
    indexTabHandler();
  }, [slider1.current, slider2.current, wltpRef.current]);

  React.useEffect(() => {
    document.addEventListener('mousedown', () => {
      setLastInteraction('click');
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        setLastInteraction('keyboard');
      }
    });

    document.addEventListener('touchstart', () => {
      setLastInteraction('swipe');
    });

    return () => {
      document.removeEventListener('mousedown', () => {
        setLastInteraction('click');
      });

      document.removeEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          setLastInteraction('keyboard');
        }
      });

      document.removeEventListener('touchstart', () => {
        setLastInteraction('click');
      });
    };
  }, []);

  const indexTabHandler = () => {
    // eslint-disable-next-line
    const activeSlide = divRefSlide1?.current?.querySelectorAll('.slick-slide')!;
    activeSlide?.forEach((slide) => {
      if (slide.classList.contains('slick-active')) {
        slide.querySelectorAll('button').forEach((button) => (button.tabIndex = 0));
      } else if (!slide.classList.contains('slick-active')) {
        slide.querySelectorAll('button').forEach((button) => (button.tabIndex = -1));
      }
    });
    textBlockTabHandler();
  };
  const textBlockTabHandler = () => {
    // eslint-disable-next-line
    const activeSlide = divRefSlide2?.current?.querySelectorAll('.slick-slide')!;

    activeSlide?.forEach((slide) => {
      if (slide.classList.contains('slick-active')) {
        slide.querySelectorAll('a').forEach((a) => (a.tabIndex = 0));
      } else if (!slide.classList.contains('slick-active')) {
        slide.querySelectorAll('a').forEach((a) => (a.tabIndex = -1));
      }
    });
  };

  const getPaginationWidth = () => {
    const width = divRefSlide2?.current?.querySelector('ul')?.offsetWidth;

    return width;
  };

  const settings1 = {
    autoplay,
    autoplaySpeed,
    accessibility: true,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    lazy: true,
    touchMove: true,
    draggable: true,
    beforeChange: (_current: number, next: number) => {
      setIsCurrent(next);
    },
    afterChange: () => {
      indexTabHandler();
    },
  };

  const settings2 = {
    accessibility: true,
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    adaptiveHeight: true,
    beforeChange: (_current: number, next: number) => {
      setIsCurrent(next);
    },
    afterChange: () => {
      indexTabHandler();
    },

    customPaging: (i: number) => {
      return (
        <React.Fragment>
          <SlideText
            data-testid="carouselPaginationLink"
            key="carouselPaginationLink"
            isAlpha={isAlpha}
          >
            {i === 0 && (
              <FlexContainer>
                <IconButton
                  icon="back"
                  size="md"
                  data-testid="carouselPrevArrow"
                  className="prev"
                  variant="tertiary"
                  aria-label={previousSlide}
                  onClick={() => {
                    slider1.current?.slickPrev();
                    const eventObj = {
                      eventAction: 'image',
                      eventName: 'feature gallery - change image',
                      elementName: 'arrow',
                      value: 'pagination bar',
                      pos: `${isCurrent - 1 === -1 ? isCurrent + 1 : isCurrent + 1}~${isCurrent - 1 === -1 ? gallery.length : isCurrent}`,
                      actionType: lastInteraction === 'swipe' ? 'click' : lastInteraction,
                      label: 'back-small',
                    };
                    trackClick(trackingService, eventObj);
                  }}
                />
                <TextButton
                  variant="tertiary"
                  id={`pagination${i + 1}`}
                  aria-label={
                    isCurrent === i
                      ? `${currentSlidAriaText} ${i + 1}`
                      : `${jumpToAriaText} ${i + 1}`
                  }
                  className="goTo"
                  onClick={() => {
                    slider1.current?.slickGoTo(i);
                    const eventObj = {
                      eventAction: 'image',
                      eventName: 'feature gallery - change image',
                      elementName: 'number',
                      value: 'pagination bar',
                      pos: `${isCurrent + 1}~${i + 1}`,
                      actionType: lastInteraction === 'swipe' ? 'click' : lastInteraction,
                      label: '',
                    };
                    trackClick(trackingService, eventObj);
                  }}
                >
                  {i + 1}
                </TextButton>
              </FlexContainer>
            )}

            {i > 0 && i < slidesCount && (
              <TextButton
                variant="tertiary"
                id={`pagination${i + 1}`}
                aria-label={
                  isCurrent === i ? `${currentSlidAriaText} ${i + 1}` : `${jumpToAriaText} ${i + 1}`
                }
                className="goTo"
                onClick={() => {
                  slider1.current?.slickGoTo(i);
                  const eventObj = {
                    eventAction: 'image',
                    eventName: 'feature gallery - change image',
                    elementName: 'number',
                    value: 'pagination bar',
                    pos: `${isCurrent + 1}~${i + 1}`,
                    actionType: lastInteraction === 'swipe' ? 'click' : lastInteraction,
                    label: '',
                  };
                  trackClick(trackingService, eventObj);
                }}
              >
                {i + 1}
              </TextButton>
            )}

            {i === slidesCount && (
              <FlexContainer>
                <TextButton
                  variant="tertiary"
                  id={`pagination${i + 1}`}
                  aria-label={
                    isCurrent === i
                      ? `${currentSlidAriaText} ${i + 1}`
                      : `${jumpToAriaText} ${i + 1}`
                  }
                  className="goTo"
                  onClick={() => {
                    slider1.current?.slickGoTo(i);
                    const eventObj = {
                      eventAction: 'image',
                      eventName: 'feature gallery - change image',
                      elementName: 'number',
                      value: 'pagination bar',
                      pos: `${isCurrent + 1}~${i + 1}`,
                      actionType: lastInteraction === 'swipe' ? 'click' : lastInteraction,
                      label: '',
                    };
                    trackClick(trackingService, eventObj);
                  }}
                >
                  {i + 1}
                </TextButton>

                <IconButton
                  data-testid="carouselNextArrow"
                  icon="forward"
                  size="md"
                  variant="tertiary"
                  className="next"
                  aria-label={nextSlide}
                  onClick={() => {
                    slider1.current?.slickNext();
                    const eventObj = {
                      eventAction: 'image',
                      eventName: 'feature gallery - change image',
                      elementName: 'arrow',
                      value: 'pagination bar',
                      pos: `${isCurrent + 1}~${isCurrent + 1 >= gallery.length ? 1 : isCurrent + 2}`,
                      actionType: lastInteraction === 'swipe' ? 'click' : lastInteraction,
                      label: 'forward-small',
                    };
                    trackClick(trackingService, eventObj);
                  }}
                />
              </FlexContainer>
            )}
          </SlideText>
        </React.Fragment>
      );
    },
  };

  const handleStart = (e: React.TouchEvent | React.MouseEvent) => {
    if ('touches' in e) {
      startX.current = e.touches[0].clientX;
    } else {
      startX.current = e.clientX;
    }
  };

  const handleEnd = (e: React.TouchEvent | React.MouseEvent) => {
    if (startX.current === null) return;

    let endX: number;

    if ('changedTouches' in e) {
      endX = e.changedTouches[0].clientX;
    } else {
      endX = e.clientX;
    }

    const deltaX = endX - startX.current;

    if (Math.abs(deltaX) > 30) {
      const direction = deltaX > 0 ? 'right' : 'left';
      const eventObj = {
        eventAction: 'image',
        eventName: 'feature gallery - change image',
        elementName: 'image',
        value: 'image bar',
        pos: `${isCurrent + 1}~${isCurrent + 1 >= gallery.length ? 1 : isCurrent + 2}`,
        actionType: 'swipe',
        label: 'forward-small',
      };
      if (direction == 'right') {
        eventObj.pos = `${isCurrent - 1 === -1 ? isCurrent + 1 : isCurrent + 1}~${isCurrent - 1 === -1 ? gallery.length : isCurrent}`;
        trackClick(trackingService, eventObj);
      } else {
        eventObj.pos = `${isCurrent + 1}~${isCurrent + 1 >= gallery.length ? 1 : isCurrent + 2}`;
        trackClick(trackingService, eventObj);
      }
    }

    startX.current = null;
  };

  return (
    <SlickSlider
      color="primary"
      data-testid="impression-tracking-box"
      id="impression-tracking-box"
      ref={ref}
      onTouchStart={handleStart}
      onTouchEnd={handleEnd}
      onMouseDown={handleStart}
      onMouseUp={handleEnd}
    >
      <UeContainer propertyPath="gallery" label="Gallery">
        <CarouselContainer isAlpha={isAlpha}>
          <SliderWrap isSingleSlide={gallery.length === 1} ref={divRefSlide1}>
            <Slider
              {...settings1}
              asNavFor={nav2!}
              adaptiveHeight
              ref={(slider: Slider) => (slider1.current = slider)}
            >
              {gallery?.map((element: any, index: number) => (
                <UeReference
                  key={getRandomInt()}
                  propertyPath={`gallery.${index}`}
                  behavior="component"
                >
                  <UeContainer propertyPath={`gallery.${index}.asset`} label="Gallery Image Asset">
                    <UeReference propertyPath={`gallery.${index}.asset`} behavior="component">
                      {(ueProps) => (
                        <ContentContainer
                          data-testid="carouselItem"
                          className="main-container"
                          size={size.width}
                          mediaHeight={mediaHeight}
                          {...ueProps}
                        >
                          {element?.asset?.assetType === constants?.assetType?.image ? (
                            <UeElement type="media" property={ueElementImageProperty} label="Image">
                              <ImageContainer className="image" size={size.width}>
                                <MaybeLink
                                  ctaUrl={element?.cta1?.ctaLink1}
                                  openIn={element?.cta1?.openIn}
                                  ariaLabel={
                                    element?.cta1?.ctaAria1 || element?.asset?.alternateDescription
                                  }
                                  onClick={() => {
                                    if (element?.cta1?.ctaLink1) {
                                      const ctaLink = String(element.cta1.ctaLink1);
                                      const eventObj = {
                                        targetURL: ctaLink,
                                        eventAction: trackingService.evaluateLinkType(
                                          ctaLink,
                                        ) as string,
                                        eventName: 'feature gallery - click on image',
                                        elementName: 'image',
                                        value: '',
                                        pos: `${index + 1}`,
                                        actionType: lastInteraction,
                                        label: element?.asset?.alternateDescription || '',
                                      };
                                      trackClick(trackingService, eventObj);
                                    }
                                  }}
                                >
                                  <ImageComponent
                                    largeImageSrc={
                                      element?.asset?.imageUrlLargeViewport?.assetValue
                                    }
                                    smallImageSrc={
                                      element?.asset?.imageUrlSmallViewport?.assetValue
                                    }
                                    preserveImageWidth={element?.asset?.preserveImageWidth}
                                    mediaHeight={mediaHeight}
                                    alternateDescription={element?.asset?.alternateDescription}
                                  />
                                </MaybeLink>
                              </ImageContainer>
                            </UeElement>
                          ) : (
                            isCurrent === index && (
                              <VideoPLayer
                                asset={element?.asset}
                                ueElementProperty={ueElementVideoProperty}
                                isCurrent={isCurrent}
                                index={index}
                                height={divRefSlide1.current?.offsetHeight}
                              />
                            )
                          )}
                        </ContentContainer>
                      )}
                    </UeReference>
                  </UeContainer>
                </UeReference>
              ))}
            </Slider>
          </SliderWrap>
          <TextBlockSlider
            data-testid="content-block"
            isSingleSlide={gallery.length === 1}
            ref={divRefSlide2}
            width={getPaginationWidth()}
            isAlpha={isAlpha}
          >
            <Slider
              {...settings2}
              asNavFor={nav1!}
              adaptiveHeight
              ref={(slider: Slider) => (slider2.current = slider)}
            >
              {gallery?.map(
                (
                  element: any,

                  index: number,
                ) => (
                  <UeReference
                    key={getRandomInt()}
                    propertyPath={`gallery.${index}`}
                    behavior="component"
                  >
                    {(ueProps) => (
                      <div key={index} {...ueProps}>
                        <TextBlockContent data-testid="carouselItemDescription" className="ctas">
                          <FeatureGalleryTextBlock
                            ctaLink={element?.cta1 ? element.cta1.ctaLink1 : null}
                            ctaText={element?.cta1 ? element.cta1.ctaText1 : null}
                            ariaLabel={element?.cta1 ? element.cta1.ctaAria1 : null}
                            title={element.title}
                            bodyText={element.bodyText}
                            openIn={element.cta1 ? element?.cta1?.openIn : null}
                            width={getPaginationWidth()}
                            slideIndex={index}
                            trackingService={trackingService}
                            isCurrent={isCurrent}
                            {...ueProps}
                          />
                        </TextBlockContent>

                        {element.legalText?.mediaDisclaimer || element.legalText?.wltpKey ? (
                          <WLTPComponent
                            mediaDisclaimer={element.legalText?.mediaDisclaimer}
                            wltpTextValues={element.legalText?.wltpKey}
                            localeService={props.localeService}
                            wltpRef={wltpRef}
                          />
                        ) : null}
                      </div>
                    )}
                  </UeReference>
                ),
              )}
            </Slider>
          </TextBlockSlider>
        </CarouselContainer>
      </UeContainer>
    </SlickSlider>
  );
};

export default FeatureGallery;
